import { oneOf } from 'prop-types';

export default oneOf([
  'album',
  'artist',
  'label',
  'project',
  'release',
  'track',
]);
